module.exports = __webpack_public_path__ + "static/media/line-height.2736fb00.svg";